import React from 'react';
import styles from './FormGroup.module.css';

/**
 * A labelled form field supporting input, select, and textarea.
 *
 * type: 'text' | 'tel' | 'email' | 'select' | 'textarea'
 */
function FormGroup({ label, type = 'text', placeholder, value, onChange, children }) {
  const inputId = label ? label.replace(/\s+/g, '-').toLowerCase() : undefined;

  let field;
  if (type === 'select') {
    field = (
      <select
        id={inputId}
        className={styles.field}
        value={value}
        onChange={onChange}
      >
        {children}
      </select>
    );
  } else if (type === 'textarea') {
    field = (
      <textarea
        id={inputId}
        className={styles.field}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    );
  } else {
    field = (
      <input
        id={inputId}
        type={type}
        className={styles.field}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    );
  }

  return (
    <div className={styles.group}>
      {label && <label htmlFor={inputId} className={styles.label}>{label}</label>}
      {field}
    </div>
  );
}

export default FormGroup;
